const blockquoteType = ['ERROR', 'SUCCESS'];
export type BlockquoteType = (typeof blockquoteType)[number];

// Matches blockquote format:
// > [!TYPE]
// > content 1
// > content 2
// > content 3
const BLOCKQUOTE_REGEX = /^\[!(\w+)\]\s*\n?([\s\S]*)$/m;

export const extractBlockquote = (
  child: string
): { type: BlockquoteType; content: string[] } | null => {
  const match = child.match(BLOCKQUOTE_REGEX);

  const matchedType = match?.[1];

  if (!!matchedType && blockquoteType.includes(matchedType)) {
    const content = match[2]
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length);

    return {
      type: matchedType,
      content,
    };
  }

  return null;
};
